export default function desmaskIfNumber(value) {
  if (!value) return "";
  // Valor puramente numérico (com separadores opcionais): remove não-dígitos
  if (/^[0-9 /.-]+$/.test(value)) {
    return value.replace(/\D/g, "");
  }
  // Espaço interno ⇒ é busca por NOME (não documento): devolve intacto
  if (/\s/.test(value.trim())) {
    return value;
  }
  // Valor alfanumérico (CNPJ alfa): remove separadores de máscara + uppercase
  return value.replace(/[.\-/\s]/g, "").toUpperCase();
}
